import { Checkbox as SharedCheckbox } from "@sportal/cdk/checkbox/Checkbox";
import "./Checkbox.scss";

export const Checkbox = SharedCheckbox;
